import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'app/appStore';
import { clearInfinityScroll, setHeaderTitle, setInfinityScrollOffset, setInfinityScrollPage } from 'shared/model';

export const useCommonSlice = () => {
	const dispatch = useDispatch();

	return {
		...useSelector((s: RootState) => s.commonSlice),
		setHeaderTitle: (title: string) => dispatch(setHeaderTitle(title)),
		setInfinityScrollOffset: (offset: number) => dispatch(setInfinityScrollOffset(offset)),
		setInfinityScrollPage: (page: number) => dispatch(setInfinityScrollPage(page)),
		clearInfinityScroll: () => dispatch(clearInfinityScroll()),
	};
};
